/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Settings_Dirs_Delete_Dialog_Description_SingleInputs */

const es_settings_dirs_delete_dialog_description_single = /** @type {(inputs: Settings_Dirs_Delete_Dialog_Description_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La carpeta "${i?.name}" y todos sus archivos serán eliminados permanentemente.`)
};

const en_settings_dirs_delete_dialog_description_single = /** @type {(inputs: Settings_Dirs_Delete_Dialog_Description_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The directory "${i?.name}" and all its files will be permanently removed.`)
};

/**
* | output |
* | --- |
* | "The directory \"{name}\" and all its files will be permanently removed." |
*
* @param {Settings_Dirs_Delete_Dialog_Description_SingleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_delete_dialog_description_single = /** @type {((inputs: Settings_Dirs_Delete_Dialog_Description_SingleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Delete_Dialog_Description_SingleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_delete_dialog_description_single(inputs)
	return en_settings_dirs_delete_dialog_description_single(inputs)
});
export { settings_dirs_delete_dialog_description_single as "settings.dirs.delete_dialog.description_single" }